import PropTypes from 'prop-types';
import React from 'react';

import cls from 'classnames';

import { l10n } from '@ott/l10n';
import LoadingDots from '@ott/loading-dots';
import Money from '@ott/money';
import Switcher from '@ott/switcher';

import styles from './Heatmap.scss';

const Heatmap = ({
  heatmap = {},
  heatmapStatus = {},
  isDirectOnly,
  onSwitch,
  showHeatmapLegend,
}) => {
  const { min, mid, max } = heatmap;
  const { initial, loading, error } = heatmapStatus;

  const hasHeatmapData = min && mid && max;
  const showLegend = showHeatmapLegend && (hasHeatmapData || loading);

  if (initial || error) {
    return null;
  }

  return (
    <div className={cls(styles.heatmap, { [styles['heatmap--onlySwitch']]: !showLegend })}>
      {heatmapStatus?.loading && (
        <div className={styles.heatmapLegend} data-locator="heatmap-legend">
          <LoadingDots />
        </div>
      )}
      {showHeatmapLegend && hasHeatmapData && (
        <div className={styles.heatmapLegend} data-locator="heatmap-legend">
          <div className={cls(styles.price, styles.min)} data-locator="min-price">
            {l10n('deals.startingFrom')}&nbsp;
            <Money amount={heatmap.min} currency={heatmap.currency} />
          </div>
          <div className={cls(styles.price, styles.mid)} data-locator="mid-price">
            {l10n('deals.startingFrom')}&nbsp;
            <Money amount={heatmap.mid} currency={heatmap.currency} />
          </div>
          <div className={cls(styles.price, styles.max)} data-locator="max-price">
            {l10n('deals.startingFrom')}&nbsp;
            <Money amount={heatmap.max} currency={heatmap.currency} />
          </div>
        </div>
      )}
      <div className={styles.switcherWrapper}>
        <Switcher
          className={styles.switcher}
          childrenClassName={{
            shape: styles.switcherShape,
            label: styles.switcherLabel,
          }}
          labelPosition="left"
          value={isDirectOnly}
          label={l10n('flightsSearchForm.showDirectFlights')}
          onChange={onSwitch}
        />
      </div>
    </div>
  );
};

Heatmap.propTypes = {
  heatmap: PropTypes.shape({
    currency: PropTypes.string.isRequired,
    min: PropTypes.number.isRequired,
    mid: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    time: PropTypes.number.isRequired,
    prices: PropTypes.PropTypes.object.isRequired,
  }),
  heatmapStatus: PropTypes.shape({
    initial: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    success: PropTypes.bool.isRequired,
    error: PropTypes.bool.isRequired,
    cancelled: PropTypes.bool.isRequired,
  }),
  isDirectOnly: PropTypes.bool.isRequired,
  onSwitch: PropTypes.func.isRequired,
};

export default Heatmap;
